import { Cart, CartImpl } from '@/modules/store/models/Cart';
import { CartItemImpl } from '@/modules/store/models/CartItem';
import { OrderPrediction } from '@/modules/store/models/OrderPrediction';

export const toCarts = (orderPrediction: OrderPrediction): Cart[] => {
  const carts: { [supplierId: string]: Cart } = {};

  orderPrediction.items.forEach((item) => {
    const predictedSales = Math.round(item.predictedSales);

    const quantity = Math.round(
      predictedSales - (item.currentStock || 0) + (item.minimumStock || 0),
    );

    if (quantity <= 0) {
      return;
    }

    const cartItem = new CartItemImpl(item.skuId, item.supplierId, quantity, {
      predictionId: orderPrediction.id,
      supplierId: item.supplierId,
      skuId: item.skuId,
      predictedSales: item.predictedSales,
      currentStock: item.currentStock,
      minimumStock: item.minimumStock,
      inTransit: item.inTransit,
    });

    if (!carts[item.supplierId]) {
      carts[item.supplierId] = new CartImpl(item.supplierId, cartItem);
    } else {
      carts[item.supplierId].addItem(cartItem);
    }
  });

  return Object.values(carts);
};
